import { inject, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngxs/store";
import { OrganizationState } from "@vp/data-access/organization";
import { Organization, TagType } from "@vp/models";
import { filterNullMap } from "@vp/shared/operators";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

@Pipe({
  name: "tagType",
  standalone: false
})
export class TagTypePipe implements PipeTransform {
  organization$: Observable<Organization | null> = inject(Store).select(
    OrganizationState.organization
  );

  public transform(tagTypeId: string): Observable<string> {
    return this.organization$.pipe(
      filterNullMap(),
      shareReplay(),
      map(org => {
        const found = org.tagTypes.find(r => r.tagTypeId === tagTypeId);
        return `${found?.displayName ?? "[tag type  not found]"}`;
      })
    );
  }
}

@Pipe({
  name: "tagTypeDisplayName",
  standalone: false
})
export class TagTypeDisplayNamePipe implements PipeTransform {
  organization$: Observable<Organization | null> = inject(Store).select(
    OrganizationState.organization
  );

  public transform(tagTypeFriendlyId: string): Observable<string> {
    return this.organization$.pipe(
      filterNullMap(),
      map(org => {
        const found = org.tagTypes.find(
          (tagType: TagType) => tagType.friendlyId === tagTypeFriendlyId
        );
        return `${found?.displayName ?? "[tag type  not found]"}`;
      }),
      shareReplay()
    );
  }
}
